import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { eitherOrWithCount, TrackedLink } from '@xingternal/xing-tracking';
import { IconWithBadge } from '@xingternal/platform-layout-icon-with-badge';

import styles from './SecondaryItem.css';

const keyToClassName = (key) =>
  ({
    premium: 'premiumLink',
    premiumUpsell: 'premiumLink',
    proJobs: 'proJobsLink',
    proBusiness: 'proBusinessLink',
  }[key]);

const SecondaryItem = ({
  activeItem,
  intl: { formatMessage },
  item,
  notifications,
}) => {
  const isActive = activeItem === item.key;
  // When active, use regular icon as fallback if no activeIcon is specified
  const IconElement = isActive ? item.activeIcon || item.icon : item.icon;
  const title = formatMessage({ id: item.title });
  const notificationCount =
    notifications && notifications[item.notificationKey || ''];
  const trackingConditions = {
    sc_o_PropActionOrigin: eitherOrWithCount(notificationCount),
  };

  const membershipClassName = keyToClassName(item.key);
  const membershipClass = cx({
    [styles[membershipClassName]]: Boolean(membershipClassName),
  });

  return (
    <li className={styles.navItem}>
      <TrackedLink
        className={cx(styles.link, membershipClass, {
          [styles.active]: isActive,
        })}
        conditions={trackingConditions}
        to={item.href}
        data-qa={`frame-hnav-${item.key}`}
        trackingKey={item.key}
      >
        <IconWithBadge
          count={notificationCount}
          icon={IconElement}
          title={title}
          className={membershipClass}
        />
        <p className={styles.title}>{title}</p>
      </TrackedLink>
    </li>
  );
};

SecondaryItem.displaName = 'SecondaryItem';

SecondaryItem.propTypes = {
  activeItem: PropTypes.string,
  intl: PropTypes.object.isRequired,
  item: PropTypes.shape({
    activeIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
    key: PropTypes.string.isRequired,
    notificationKey: PropTypes.string,
    title: PropTypes.string.isRequired,
  }),
  notifications: PropTypes.object,
};

export { SecondaryItem };
